import React from 'react';
import Modal from '../../../../../Components/Modal/Modal';
import { NCZIEntry } from '../../../Interfaces/ncziTypes';
import { Size } from '../../../../../Enums/Size.enum';
import { useTreatmentContext } from '../../../../../Services/TreatmentContext';
import ElectronicDPNHistoryModalContent from './ElectronicDPNHistoryModalContent';

interface Props {
	opened: boolean;
	onClose: (needReload: boolean) => void;
	patientIdentifier: string;
	electronicConfirmation: NCZIEntry;
	disableCreate?: boolean;
}

const ElectronicDPNHistoryModal: React.FC<Props> = props => {
	const {
		opened,
		onClose,
		patientIdentifier,
		electronicConfirmation,
		disableCreate = false,
	} = props;

	const { isCase } = useTreatmentContext();

	return (
		<Modal
			opened={opened}
			onClose={() => onClose(false)}
			fullScreen={false}
			size={Size.LG}
			wrapChat={isCase}>
			<Modal.Header title='nczi.electronicDPN.history.title' firstUpper />
			<Modal.Content>
				<ElectronicDPNHistoryModalContent
					onClose={onClose}
					patientIdentifier={patientIdentifier}
					electronicConfirmation={electronicConfirmation}
					disableCreate={disableCreate}
				/>
			</Modal.Content>
		</Modal>
	);
};

export default ElectronicDPNHistoryModal;
